// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__ftMJe","blue":"style_blue__92E6E","orange":"style_orange__3_InU","green":"style_green__399Kk","red":"style_red__2jcM6","gray":"style_gray__3XGbJ"};